import { refreshCartCount, refreshMiniCart, refreshUpsells } from './utils.js';

const collectCartItems = () => {
  const products = document.querySelectorAll('.c-buy-together__product[data-available-for-sale]');
  return Array.from(products, (el) => ({
    id: el.getAttribute('data-product-id'),
    quantity: 1,
  }));
};

const handleAddToCart = async (items, button) => {
  if (button) {
    button.disabled = true;
    button.style.opacity = '0.5';
  }
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    if (button) {
      button.disabled = false;
      button.style.opacity = '';
    }

    document.getElementById('cart-icon-bubble')?.click();

    refreshCartCount();
    refreshMiniCart();

    setTimeout(() => {
      refreshUpsells();
    }, 1000);
  } catch (err) {
    if (button) {
      button.disabled = false;
      button.style.opacity = '';
    }
    console.error('Cart error:', err);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const addButton = document.querySelector('#c-buy-together__add-to-cart');
  const items = collectCartItems();

  if (addButton && items.length) {
    addButton.addEventListener('click', () => handleAddToCart(items, addButton));
  }
});
